import type { FaireProductEntity } from "../../entity_types/product";

export const p_7t4m4ggna5: FaireProductEntity = {
  token: "p_7t4m4ggna5",
  type: "product",
  name: "Limonana Travel Tin",
  brandName: "Blue Ocean Traders",
  imageUrl:
    "https://cdn.faire.com/fastly/648d69d9135628396b8330f4c9574bb0546a25bfcc30214c1b5949c64d37cc50.jpeg",
  priceDollars: 2.89,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/bd8b34c3fb60c3c6466ce840e918dd983e84907ea2b17413e52bb23a5173ed97.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
